import React from 'react';
import { useRoutes } from 'react-router-dom';
import '../src/main/styles/common.scss';

import Home from './main/pages/Home';

const Editor = React.lazy(() => import('./main/pages/Editor'));

const App: React.FC = (): JSX.Element => {
    const mainRoutes = {
        path: '/',
        element: <Home />,
        children: [
            { path: '*', element: <Home /> },
            { path: '/', element: <Home /> },
        ],
    };
    const editorRoutes = {
        path: 'editor',
        element: <Editor />,
        children: [
            { 
                path: 'editor', 
                element: <Editor />,
            },
            { 
                path: ':id', 
                element: <Editor />,
            },
        ],
    };
    const routing = useRoutes([mainRoutes, editorRoutes]);

    return <>{routing}</>;
};

export default App;
